// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * angular-ui-notification - Angular.js service providing simple notifications using Bootstrap 3 styles with css transitions for animating
 * @author Alex_Crack
 * @version v0.3.6
 * @link https://github.com/alexcrack/angular-ui-notification
 * @license MIT
 */
.ui-notification
{
    position: fixed;
    z-index: 9999;

    width: 300px;

    -webkit-transition: all ease .5s;
         -o-transition: all ease .5s;
            transition: all ease .5s;

    color: #fff;
    border-radius: 0;
    background: #337ab7;
    box-shadow: 5px 5px 10px rgba(0, 0, 0, .3);
}
.ui-notification.clickable
{
    cursor: pointer;
}
.ui-notification.clickable:hover
{
    opacity: .7;
}
.ui-notification.killed
{
    -webkit-transition: opacity ease 1s;
         -o-transition: opacity ease 1s;
            transition: opacity ease 1s;

    opacity: 0;
}
.ui-notification > h3
{
    font-size: 14px;
    font-weight: bold;

    display: block;

    margin: 10px 10px 0 10px;
    padding: 0 0 5px 0;

    text-align: left;

    border-bottom: 1px solid rgba(255, 255, 255, .3);
}
.ui-notification a
{
    color: #fff;
}
.ui-notification a:hover
{
    text-decoration: underline;
}
.ui-notification > .message
{
    margin: 10px 10px 10px 10px;
}
.ui-notification.warning
{
    color: #fff;
    background: #f0ad4e;
}
.ui-notification.error
{
    color: #fff;
    background: #d9534f;
}
.ui-notification.success
{
    color: #fff;
    background: #5cb85c;
}
.ui-notification.info
{
    color: #fff;
    background: #5bc0de;
}
`, "",{"version":3,"sources":["webpack://./node_modules/angular-ui-notification/dist/angular-ui-notification.css"],"names":[],"mappings":"AAAA;;;;;;EAME;AACF;;IAEI,eAAe;IACf,aAAa;;IAEb,YAAY;;IAEZ,gCAAgC;SAC3B,2BAA2B;YACxB,wBAAwB;;IAEhC,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,0CAA0C;AAC9C;AACA;;IAEI,eAAe;AACnB;AACA;;IAEI,WAAW;AACf;AACA;;IAEI,mCAAmC;SAC9B,8BAA8B;YAC3B,2BAA2B;;IAEnC,UAAU;AACd;AACA;;IAEI,eAAe;IACf,iBAAiB;;IAEjB,cAAc;;IAEd,wBAAwB;IACxB,kBAAkB;;IAElB,gBAAgB;;IAEhB,gDAAgD;AACpD;AACA;;IAEI,WAAW;AACf;AACA;;IAEI,0BAA0B;AAC9B;AACA;;IAEI,2BAA2B;AAC/B;AACA;;IAEI,WAAW;IACX,mBAAmB;AACvB;AACA;;IAEI,WAAW;IACX,mBAAmB;AACvB;AACA;;IAEI,WAAW;IACX,mBAAmB;AACvB;AACA;;IAEI,WAAW;IACX,mBAAmB;AACvB","sourcesContent":["/**\n * angular-ui-notification - Angular.js service providing simple notifications using Bootstrap 3 styles with css transitions for animating\n * @author Alex_Crack\n * @version v0.3.6\n * @link https://github.com/alexcrack/angular-ui-notification\n * @license MIT\n */\n.ui-notification\n{\n    position: fixed;\n    z-index: 9999;\n\n    width: 300px;\n\n    -webkit-transition: all ease .5s;\n         -o-transition: all ease .5s;\n            transition: all ease .5s;\n\n    color: #fff;\n    border-radius: 0;\n    background: #337ab7;\n    box-shadow: 5px 5px 10px rgba(0, 0, 0, .3);\n}\n.ui-notification.clickable\n{\n    cursor: pointer;\n}\n.ui-notification.clickable:hover\n{\n    opacity: .7;\n}\n.ui-notification.killed\n{\n    -webkit-transition: opacity ease 1s;\n         -o-transition: opacity ease 1s;\n            transition: opacity ease 1s;\n\n    opacity: 0;\n}\n.ui-notification > h3\n{\n    font-size: 14px;\n    font-weight: bold;\n\n    display: block;\n\n    margin: 10px 10px 0 10px;\n    padding: 0 0 5px 0;\n\n    text-align: left;\n\n    border-bottom: 1px solid rgba(255, 255, 255, .3);\n}\n.ui-notification a\n{\n    color: #fff;\n}\n.ui-notification a:hover\n{\n    text-decoration: underline;\n}\n.ui-notification > .message\n{\n    margin: 10px 10px 10px 10px;\n}\n.ui-notification.warning\n{\n    color: #fff;\n    background: #f0ad4e;\n}\n.ui-notification.error\n{\n    color: #fff;\n    background: #d9534f;\n}\n.ui-notification.success\n{\n    color: #fff;\n    background: #5cb85c;\n}\n.ui-notification.info\n{\n    color: #fff;\n    background: #5bc0de;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
